import { AgencyNoticeExhibition } from "~/apps/shared/constants/enums";
import { api } from "~/apps/shared/services/api";

import { ListClientAgencyNoticesResponse } from "../dtos/agency-notice.dto";
import { getAuthorizationHeader } from "../helpers/user.helper";
import * as agencyNoticeParser from "../parsers/agency-notice.parser";

export async function listClientAgencyNotices(
  clientToken: string,
  exhibition?: AgencyNoticeExhibition,
) {
  return await api
    .request<ListClientAgencyNoticesResponse>({
      headers: getAuthorizationHeader(),
      method: "GET",
      params: {
        exhibition,
      },
      url: `/booking/clients/${clientToken}/agency-notices/published`,
    })
    .then(({ data }) => agencyNoticeParser.parseAgencyNotices(data));
}
